import { render, staticRenderFns } from "./MintalMesPrdCraftConfigList.vue?vue&type=template&id=b20db1a8&"
import script from "./MintalMesPrdCraftConfigList.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdCraftConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports